import {Component, signal, inject, ChangeDetectionStrategy} from "@angular/core"
import {MatButtonModule} from "@angular/material/button"
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle} from "@angular/material/dialog"
import {StateLabel} from "@labels"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-dialog",
    templateUrl: "dialog.component.html",
    styleUrls: ["dialog.component.scss"],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule],
})
export class DialogComponent {
    readonly $title = signal("Title not set.")
    readonly $message = signal("Message not set.")
    readonly $confirmLabel = signal("No confirm label set.")
    readonly $cancelLabel = signal("No cancel label set.")
    readonly $otherActions = signal<StateLabel<string>[] | undefined>(undefined)
    readonly $isDestructive = signal(false)
    readonly dialogRef = inject(MatDialogRef<DialogComponent>)
    readonly data = inject<{
        title: string
        message: string
        confirmLabel: string
        cancelLabel: string
        isDestructive: boolean
        otherActions?: StateLabel<string>[]
    }>(MAT_DIALOG_DATA)

    constructor() {
        this.$title.set(this.data.title)
        this.$message.set(this.data.message)
        this.$confirmLabel.set(this.data.confirmLabel)
        this.$cancelLabel.set(this.data.cancelLabel)
        this.$isDestructive.set(this.data.isDestructive)
        this.$otherActions.set(this.data.otherActions)
    }

    cancelAction(): void {
        this.dialogRef.close(false)
    }

    confirmAction(value?: string): void {
        this.dialogRef.close(value ?? true)
    }
}
